import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { FiRefreshCw } from "react-icons/fi";
import axios from "axios";
import SweetAlertHelper from "../AhsBot/SweetAlertHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
} from "@fortawesome/free-regular-svg-icons";
import { faRobot, faUser } from "@fortawesome/free-solid-svg-icons";
import {
  faMicrophone,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useSpeechSynthesis } from "react-speech-kit";
import { faVolumeUp, faPause } from "@fortawesome/free-solid-svg-icons";
import { ApiHelper } from "../AhsBot/apiHelper";
import { environment } from "../AhsBot/environment";
import {
  faChevronRight,
  faChevronLeft,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import { format } from "date-fns";
import { openaiEnv } from "../AhsBot/chatbot.env";
import "./SSTAI.css";
import sstlogo from "../../assets/images/SSTLogo.jpg";
import { useNavigate, useLocation } from "react-router-dom";

let demo = "";
let file;
let html_table;
let specialistName = "";
let sub_specialistName = "";
let subSpecialistNames = ([] = []);
let practice_name = "";
let physician_name = "";
let SecondOpinionjson;
let SecondOpinionjson1;
let SecondOpinionjsonObject;
let patientData;
let Documentjson;
let patientDoc;
let pendingReferalOpinionList;
let PendingSecondOpinionjsonObject;
let PendingSecondOpinionjson;
let checkboxtable;
let url;
let audioBlob;
let sumres;
let patient_id;
let UploadVideojson;
var webkitSpeechRecognition;
let loggedInUserName = "David"
let fileNames;
let videosum;
let r1;
let azureUploadResponse;
let uploadVideoFileUrl;
let uploadVideoFileName;
let bill_json;
let uploadFileUrl;
let live_transcript = "";
let UploadPrescriptionObject;
let thread_id = 0;
let loggedInUserEmail = "lilah_tyler@yopmail.com"
let loggedInUserRoleId = 2
let loggedInUserId = 891
let ACS_API = openaiEnv.ACS_API;
let OPENAI_API = openaiEnv.OPENAI_API;
let phpbaseurl = environment.phpApiUrl;

const SSTAI = () => {
  function capitalizeFirstLetter(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  const navigate = useNavigate();
  let empName = localStorage.getItem("loggedInUserName") || "David Clair";
  let nameParts = empName.split(" ");
  let firstName = capitalizeFirstLetter(nameParts[0]);
  let lastName = capitalizeFirstLetter(nameParts[nameParts.length - 1]);
  let updatedLoggedInUserName = firstName + " " + lastName;
  const [response, setResponse] = useState("");
  const [textBeforeButtons, SettextBeforeButtons] = useState("");
  const [buttonNames, SetbuttonNames] = useState([]);
  const [buttonClicked, setButtonClicked] = useState(null);
  const [coeList, setcoeList] = useState(null);
  const [dropdownNames, SetDropdownNames] = useState([]);
  const [isfaqbutton, Setisfaqbutton] = useState(false);
  const [isvdobutton, Setisvdobutton] = useState(false);
  const [isGeneralSearch, setIsGeneralSearch] = useState(true);
  const [isotherQue, SetisOtherQue] = useState(false);
  const [isvideoQue, SetisVideoQue] = useState(false);
  const [isexpbutton, Setisexpbutton] = useState(false);
  const [messagesa, setmessagesa] = useState([
    {
      text: `Hi, Mr. ${lastName}. How can I help you today?`,
      user: false,
    },
  ]);
  const { speak, cancel, speaking, voices } = useSpeechSynthesis();
  const [isSpeechPaused, setIsSpeechPaused] = useState(false);
  const chatContainerRef = useRef(null);
  const lastMessageRef = useRef(null);
  const [documentURLRes, setDocumentURLRes] = useState(null);
  const [clickedButton, setClickedButton] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [pdfUrl, SetPdfUrl] = useState([]);
  const [imageUrl, SetImageUrl] = useState([]);
  const [videoUrl, setVideoUrl] = useState([]);
  const [htmlFormat, setHtmlFormat] = useState([]);
  let pageNumber = sessionStorage.getItem("pageNumber");
  let currentLinkGpt = sessionStorage.getItem("currentLinkGpt");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [selectedFile3, setSelectedFile3] = useState(null);
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [answer, setAnswer] = useState("");
  const [threads, setThreads] = useState([]);
  const [last7DaysThreads, setLast7DaysThread] = useState([]);
  const [threadApiCalled, setThreadApiCalled] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [activeclicked, setActiveClicked] = useState(false);
  const [threadButtonClicked, setThreadButtonClicked] = useState(false);
  const [activeThread, setActiveThread] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isTranscriptOpen, setIsTranscriptOpen] = useState(true);
  const [olderThread, setOlderThread] = useState([]);
  const [todayThread, setTodayThread] = useState([]);
  const [transcript, setTranscript] = useState("");
  const [text, setText] = useState("");
  const [isMicrophoneOn, setIsMicrophoneOn] = useState(false);
  const [summaryValue, setSummaryValue] = useState("");
  const [micflag, setMicFlag] = useState(false);
  const [documentLists, setdocumentLists] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [isdictationStarted, setIsDictationStarted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const mediaRecorderRef = React.useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const intervalRef = useRef(null);
  const currentDateTime = format(new Date(), "yyyyMMdd_HHmmss");
  const fileName = `${empName}_${currentDateTime}.mp3`;
  const [rules, setRules] = useState([]);
  const [authFile, setAuthFile] = useState("");
  const [isChatActive, setIsChatActive] = useState(false);

  const formatTimeLeft = () => {
    let minutesNum = Math.floor(timeLeft / 60);
    let secondsNum = timeLeft % 60;
    // Convert to string and pad with zeros
    let minutes = String(minutesNum).padStart(2, "0");
    let seconds = String(secondsNum).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    const handleUnload = () => {
      localStorage.setItem("isLoggedIn", "false");
    };
  
    window.addEventListener("beforeunload", handleUnload);
  
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);
  
  useEffect(() => {
    const fetchBlobData = async () => {
      try {
        const response = await fetch(
          "https://blobtimesheet.blob.core.windows.net/insurancedocs/Denialrules.txt"
        );
        // console.log("response", response)
        const data = await response.text();
        // console.log("data", data)
        const rulesArray = data
          .split("\n")
          .filter((rule) => rule.trim() !== ""); // Remove empty lines
        // console.log("rulesArray", rulesArray, typeof(rulesArray))
        setRules(rulesArray);
      } catch (error) {
        console.error("Error fetching blob data:", error);
      }
    };
    fetchBlobData();
  }, []);

  useEffect(() => {
    console.log("Loading state:", isLoading); // Log state whenever it changes
  }, [isLoading]);

  useEffect(() => {
    if (showTimer) {
      intervalRef.current = setInterval(() => {
        // setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
        setTimeLeft((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [showTimer]);

  const toggleTranscript = () => {
    setIsTranscriptOpen(!isTranscriptOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [filename1, setFilename1] = useState(null);
  const [filename2, setFilename2] = useState(null);
  const [filename3, setFilename3] = useState(null);
  const [showFileUpload, SetShowFileUpload] = useState(false);

  useEffect(() => {}, [isSidebarOpen]);

  const initialContext = [
    {
      role: "system",
      content: `
      You are a friendly physician Assistance ChatBot, first greet the user with their last name Dr.${lastName} (note : take only last name with adding initial as "Dr." and greet).`,
    },
    {
      role: "user",
      content: "Hi",
    },
  ];
  
  const [context, setContext] = useState(initialContext);
  const hasMessages = (threads) => {
    return true;
  };

  const handleCopyToClipboard = (text, index) => {
    navigator.clipboard
      .writeText(text)
      .then(() => setCopiedIndex(index))
      .catch((err) => console.error("Unable to copy to clipboard", err));
  };

  const handleVolumeIconClick = (text) => () => {
    if (speaking) {
      if (isSpeechPaused) {
        speak({ text: text, voice: voices[4] });
        setIsSpeechPaused(false);
      } else {
        // Pause speech synthesis
        cancel();
        setIsSpeechPaused(true);
      }
    } else {
      // Start speech synthesis
      speak({ text: text, voice: voices[4] });
      setIsSpeechPaused(false);
    }
  };

  const handleReportSelectAPI = async () => {    
    const body = new FormData();
    body.append("fileKey", file);
    let apiurl = phpbaseurl + ApiHelper.php_uploadAzureFile;
    try {
      const res = await axios.post(        
        `${apiurl}`,
        body
      );      
      let filenameup = res.data.commandResult.data.fileName;
      let fileurl = res.data.commandResult.data.fileUrl;
      const obj={
        "pdf_blob_urls":[
          fileurl
        ]
    }
      r1= await axios.post(`${OPENAI_API}pdf_to_json`,obj);      
      const answerArray = r1.data.answer; 
      const rjsonString = JSON.stringify(answerArray);      
      return rjsonString;   
    } 
    catch (error) {
      console.error("Error:", error);
    }
  };

  const extractDropdownopt = (text) => {
    console.log("Dropdown: ", text);
    const startIndex = text.toLowerCase().indexOf("dropdown: ['") + 11;
    const endIndex = text.indexOf("']", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      console.log("Testing......");
      const buttonString = text.substring(startIndex, endIndex);
      const options = buttonString
        .split("', '")
        .map((option) => option.replace(/'/g, ""));
      return options;
    }
    return [];
  };

  const send_msg_func = async (req, respo, id) => {
    const obj2 = {
      request: req,
      response: respo,
      threadId: id,
    };
    const add_msg = await axios.post(`${ACS_API}send_msg`, obj2);
    // const add_msg = await axios.post(`http://127.0.0.1:5000/send_msg`, obj2);
  };

  const categorizeThreads = (threads_list) => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const todayThreads = [];
      const last7DaysThreads = [];
      const olderThreads = [];

      threads_list.forEach((thread) => {
        const threadDate = new Date(thread.date);
        const last7DaysDate = new Date(today);
        last7DaysDate.setDate(today.getDate() - 7);
        if (threadDate >= today) {
          todayThreads.push(thread);
        } else if (threadDate >= last7DaysDate) {
          last7DaysThreads.push(thread);
        } else {
          olderThreads.push(thread);
        }
      });
      todayThreads.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      last7DaysThreads.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      olderThreads.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      setTodayThread(todayThreads);
      setLast7DaysThread(last7DaysThreads);
      setOlderThread(olderThreads);
      // console.log("Last 7 days: ", last7DaysThreads);
    } catch (error) {
      console.log("Error:-", error);
    }
  };

  const get_all_threads = async () => {
    try {
      const response = await axios.get(
        `${ACS_API}get_all_threads/${loggedInUserEmail}`
      );

      const names = response.data;
      const id = names.id;
      categorizeThreads(names);
      const transformedMessages = names.map((item) => [item.name, item.id]);
      setThreads(transformedMessages);
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const loadThread = async (thread, index) => {
    handleButtonClick();
    setButtonClicked("Start new Conversation");
    setIsButtonDisabled(false);
    setThreadButtonClicked(true);
    setActiveThread(index);
    console.log("thread id: ", thread);

    try {
      const t_id = thread.id;
      const name = thread.name;
      const response = await axios.get(`${ACS_API}get_full_thread/${t_id}`);
      // const response = await axios.get(`http://127.0.0.1:5000/get_full_thread/${t_id}`);
      const chat = response.data;
      setButtonClicked("Start new Conversation");
      setIsButtonDisabled(false);
      const id = chat.row;
      const transformedMessages = chat.map((item) => {
        const userMsg = { text: item.question, user: true };
        let aiResponse = { text: item.answer, user: false };
        return [userMsg, aiResponse];
      });
      // Flatten the array of arrays into a single array
      const flattenedMessages = [].concat(...transformedMessages);
      try {
        setmessagesa(flattenedMessages);
      } catch (err) {
        console.log("error: ", err);
      }
    } catch (error) {
      console.error("Error: ", error);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const handleButtonClick = () => {
    setClicked(!clicked);
  };

  const resetAllData = () => {
    SweetAlertHelper.showConfirm(
      "Are you sure want to reset all the data?",
      () => {
        window.location.reload();
      }
    );
  };

  const extractButtonNames = (text) => {
    const startIndex = text.indexOf("Buttons: ['") + 11;
    const endIndex = text.indexOf("']", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      const buttonString = text.substring(startIndex, endIndex);
      return buttonString.split("', '");
    }
    return [];
  };

  useEffect(() => {
    // initialquestionCount();
    get_all_threads();
  }, []);


  const extractdenialjson = async (text) => {
    console.log("reason before function call:", rules);
    const jsonStartIndex = text.lastIndexOf("{");
    const jsonEndIndex = text.indexOf("}", jsonStartIndex) + 1;
    const jsonString = text.substring(jsonStartIndex, jsonEndIndex);
    const json = JSON.parse(jsonString);
    const reason = json.reason;
    console.log("reason", reason);
    const updatedRules = [...rules];
    // Append the new rule to the cloned array
    updatedRules.push(reason);
    console.log("updatedRules", updatedRules);
    // Update the state with the new array including the appended rule
    setRules(updatedRules);
    return reason;
  };

  const extractbill = async (text) => {
    console.log("extracting bill json from ", text);
    const jsonStartIndex = text.lastIndexOf("```json") + 7;
    const jsonEndIndex = text.indexOf("```", jsonStartIndex);
    const jsonString = text.substring(jsonStartIndex, jsonEndIndex);
    //convert jsonString to json object
    bill_json = JSON.parse(jsonString);
    // bill_json = jsonString;
    console.log("Bill : ", bill_json);
    console.log("Bill : ", typeof bill_json);
    const textbefore_1 = text.indexOf("Here is the corrected");
    const textBeforeJson = text.substring(0, textbefore_1);
    const textAfterJson = text.substring(jsonEndIndex + 3);
    const buttonIndex = textAfterJson.lastIndexOf("Buttons:");
    const finalText = textBeforeJson + textAfterJson;
    console.log("text Before bill ", textBeforeJson);
    console.log("text After bill ", textAfterJson);

    return finalText;
  };

  const upload_authorization_file = async () => {
    try {
      const file_payload = new FormData();
      // console.log("file name: ", fileNames);
      file_payload.append("file", file);
      let res = await axios.post(
        `${OPENAI_API}validate_file`,
        // `http://127.0.0.1:5000/validate_file`,
        file_payload
      );
      console.log("response: ", res.data.message);
      return res.data.message;
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const get_rules_url = async () => {
    const reasonsString = rules;
    console.log("reason str: ", reasonsString);
    try {
      let rules_payload = {
        rules: reasonsString,
      };
      let rule_res = await axios.post(
        `${OPENAI_API}update_rules`,
        rules_payload
      );
      let rules_url = rule_res.data.rules_url;
      console.log("response rules: ", rules_url);
      return rules_url;
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const get_bill_url = async () => {
    try {
      let pdf_payload = {
        template_name: "insurance_template.html",
        data: bill_json,
      };
      let pdf_url = await axios.post(
        // `http://127.0.0.1:5000/generate_pdf`,
        `${OPENAI_API}generate_html_to_pdf`,
        pdf_payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("pdf_url: ", pdf_url);
      return pdf_url;
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const get_bill_patient = async () => {
    try {
      let pdf_payload = {
        template_name: "patient_template.html",
        data: bill_json,
      };
      let pdf_url = await axios.post(
        // `http://127.0.0.1:5000/generate_patient_pdf`,
        `${OPENAI_API}generate_html_to_pdf`,
        pdf_payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("pdf_url: ", pdf_url);
      return pdf_url;
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const report = async (user_question, url) => {
    console.log("user_question...", url.toLowerCase().endsWith(".pdf"));
    let response;
    const urls = Array.isArray(url) ? url : [url];
    const isPdf = urls.every(
      (url) =>
        url.toLowerCase().endsWith(".pdf") ||
        url.toLowerCase().endsWith(".docx")
    );
    const isImage = urls.every(
      (url) =>
        url.toLowerCase().endsWith(".jpg") ||
        url.toLowerCase().endsWith(".jpeg") ||
        url.toLowerCase().endsWith(".dcm") ||
        url.toLowerCase().endsWith(".dicom") ||
        url.toLowerCase().endsWith(".png")
    );
    const isVideo = urls.every(
      (url) =>
        url.toLowerCase().endsWith(".webm") ||
        url.toLowerCase().endsWith(".mp4")
    );
    console.log("user_question 2...", url.toLowerCase().endsWith(".pdf"));
    try {
      if (isPdf) {
        console.log("in pdf if");
        // Create a separate body object for the PDF API call
        const pdfBody = {
          question: user_question,
          pdf_blob_urls: [url],
        };

        response = await axios.post(`${OPENAI_API}reports`, pdfBody);
      }
      if (response) {
        console.log(response.data.answer, "response.data.answer");
        return response.data.answer;
      } else {
        console.log("No valid API call was made.");
      }
    } catch (error) {
      console.error("Error calling Python API:", error.message);
    }
  };

  window.demoTest = (url) => {
    SweetAlertHelper.showConfirm(
      "Are you sure you want to open this documents in new tab?",
      () => {
        window.open(url, "_blank");
      }
    );
  };

  window.printDocumentUrl = (url) => {
    console.log(
      "condition: ",
      url.toLowerCase().endsWith(".pdf") || url.toLowerCase().endsWith(".docx")
    );
    if (
      url.toLowerCase().endsWith(".pdf") ||
      url.toLowerCase().endsWith(".docx")
    ) {
      SetPdfUrl([...pdfUrl, url]);
      console.log("url of pdf", pdfUrl);
    } else if (
      url.toLowerCase().endsWith(".jpg") ||
      url.toLowerCase().endsWith(".jpeg") ||
      url.toLowerCase().endsWith(".png") ||
      url.toLowerCase().endsWith(".")
    ) {
      console.log("url of image", url);
      SetImageUrl([...imageUrl, url]);
    } else if (
      url.toLowerCase().endsWith(".webm") ||
      url.toLowerCase().endsWith(".mp4")
    ) {
      setVideoUrl([...videoUrl, url]);
      console.log("url of video: ", videoUrl);
      console.log("url of video 1: ", url);
    } else {
      console.error("Invalid PDF URL:", url);
    }
  };

  window.testUpdatedRespond = (btntxt) => {
    demo = btntxt;
    // setResponse("btntxt");
    let nContext = [...context, { role: "user", content: btntxt }];
    setContext(nContext);
    const userMessage = {
      text: btntxt,
      user: true,
    };
    let aiResponse = {
      text: "please wait...",
      user: false,
    };
    setmessagesa([...messagesa, userMessage, aiResponse]);
    // //speak({ text: aiResponse.text, voice: voices[4] });
    getCompletionFrommessagesa(nContext);
  };

  window.testAutoRespond = (btntext) => {
    demo = btntext;
    // setResponse(btntext);
    let nContext = [...context, { role: "user", content: btntext }];
    setContext(nContext);
    const userMessage = {
      text: btntext,
      user: true,
    };
    let aiResponse = {
      text: "please wait...",
      user: false,
    };
    setmessagesa([...messagesa, userMessage, aiResponse]);
    // //speak({ text: aiResponse.text, voice: voices[4] });
    getCompletionFrommessagesa(nContext);
  };

  let claimDocument =
    "https://blobtimesheet.blob.core.windows.net/pdfs/Cigna Health.pdf";

  const newChat = `
  You are a friendly physician Assistance ChatBot, first greet the user with their last name Dr.${loggedInUserName}. \
   `;

  const patient_david = `
    {
      "patient": {
        “patient_name”: {
          "First name": "David",
          “Last name”: “Clair”,
        },
        "date_of_birth": "1997-05-25",
        "gender": "Male",
        "address": "132, My Street, Kingston, New York 12401",
        "phone": "555-153-4361",
        "email": "david_clair@yopmail.com",
        “status”: “married”, 
      },
      "insurance": {
        "primary_insurance": {
          "insured’s_name": {
        “First_name”: "Laura",
        “last_name”: “Carter”,
        “Middle_name”: “Nathan”
          },
          "insured’s_address": "264, My Street, Kingston, New York 12401",
          “insured_date_of_birth”: “1994-01-20”,
          "company_name": "Cigna",
          "policy_number": "HC987654",
          "group_id": "G54321",
          “insured_ID”: “187-837-3728”,
          "relationship_to_patient": "Spouse",
          "plan_name": "PPO",
          “plan_type”: “Group health plan”
        },
        "secondary_insurance": {
          "insured’s_name": {
        “First_name”: "Carol",
        “last_name”: “Smith”,
        “Middle_name”: “Finn”
          },
          “Insured’s_address”: “164, Greenwich St, Washington country, NY”,
          “insured’s_date_of_birth”: “1981-09-23”,
          "company_name": "Bluestone",
          "policy_number": "CP789012",
          "group_id": "H04121",
          “insured_ID”: “291-989-2829”,
          "plan_holder_name": "Carol Smith",
          "relationship_to_patient": "Parent",
          "plan_name": "ClassicHSA",
          “plan_type”: “group health plan”
        },
      "medicare_coverage": {
        "part_a": {
          "deductible": 1484,
          "coinsurance_days": 61,
          "lifetime_reserve_days": 60
        }
      }
    }`;
  const ER_Ambulance = `
    {
      "Service provider name": "The heart centre",
      "Service provider address": "33 grand st. suite 53, kingston ",
      "Service provided": {
      "Date": "05-01-2023"  
      "services": {
        "1": "Emergency room",
        "2": "Ambulance",
        },
      "Unit": {
        "1": " hour",
        "2": " km",
      },
      "Quantity": {
        "1": "1",
        "2": "2",
        },
        "Charges": {
        "1": "$100 per unit",
        "2": "$200 per unit",
        }
      }
    }
    `;
  const Syringe_Room = `“Service provided”: {
      “services”: {
    “1”: “Syringe with needle, Sterile 3cc”,
    “2”: “Hospital long term care, room and board”
    }
      “Unit”: {
        “1”: “cc”,
        “2”: “diem”
      }
      “Quantity”: {
        “1”: “3”,
        “2”: “5”
      },
      "Charges": {
        "1": "$150 per unit",
        "2": "$280 per unit",
      }
    }
    `;
  const policy = `{
      "MedicalPlans": {
        "PPO": {
          "AnnualDeductible": {
            "EmployeeOnly": "$1,250",
            "EmployeePlusDependents": "$2,500"
          },
          "AnnualOutOfPocketMaximum": {
            "EmployeeOnly": "$5,000",
            "EmployeePlusDependents": "$10,000"
          },
          "AdultAndPediatricPreventiveCare": "No Charge",
          "AnnualOBGYNExam": "No Charge",
          "RoutineMammograms": "No Charge",
          "OfficeVisit": "$35 copay per visit",
          "SpecialistOfficeVisit": "$45 copay per visit",
          "MaternityCareOfficeVisits": "$35 copay per visit",
          "DiagnosticServicesXrayAndLabTests": "No Charge",
          "AdvanceRadiologyMRIsAndCTScans": "30% after deductible",
          "HospitalInpatientAndOutpatientSurgery": "30% after deductible",
          "EmergencyRoom": "No Charge after $50 copay",
          "Ambulance": "No Charge after $50 copay",
          "Prescriptions": {
            "Generic": "$10 copay",
            "NameBrand": "$45 copay",
            "BrandOutsideOfFormulary": "$60 copay",
            "MailOrderPrescriptions90DaySupply": {
              "Generic": "$20 copay",
              "NameBrand": "$90 copay",
              "BrandOutsideOfFormulary": "$80 copay"
            }
          },
        },
        "ClassicHSA": {
          "AnnualDeductible": {
            "EmployeeOnly": "$2,000",
            "EmployeePlusDependents": "$4,000"
          },
          "AnnualOutOfPocketMaximum": {
            "EmployeeOnly": "$4,500",
            "EmployeePlusDependents": "$9,000",
            "Notes": "Family OOP Max has embedded individual max of $6,850"
          },
          "AdultAndPediatricPreventiveCare": "No Charge",
          "AnnualOBGYNExam": "No Charge",
          "RoutineMammograms": "No Charge",
          "OfficeVisit": "20% after deductible",
          "SpecialistOfficeVisit": "20% after deductible",
          "MaternityCareOfficeVisits": "20% after deductible",
          "DiagnosticServicesXrayAndLabTests": "20% after deductible",
          "AdvanceRadiologyMRIsAndCTScans": "20% after deductible",
          "HospitalInpatientAndOutpatientSurgery": "20% after deductible",
          "EmergencyRoom": "20% after deductible",
          "Ambulance": "20% after deductible",
          "Prescriptions": {
            "Generic": "$20 copay after deductible",
            "NameBrand": "20% after deductible",
            "BrandOutsideOfFormulary": "20% after deductible",
            "MailOrderPrescriptions90DaySupply": {
              "Generic": "$20 copay after deductible",
              "NameBrand": "$20 copay after deductible",
              "BrandOutsideOfFormulary": "$20 copay after deductible"
            }
          },
        },
        "PremierHSA": {
          "AnnualDeductible": {
            "EmployeeOnly": "$2,000",
            "EmployeePlusDependents": "$4,000"
          },
          "AnnualOutOfPocketMaximum": {
            "EmployeeOnly": "$3,000",
            "EmployeePlusDependents": "$6,000",
            "Notes": "Family OOP Max has embedded individual max of $4,850"
          },
          "AdultAndPediatricPreventiveCare": "No Charge",
          "AnnualOBGYNExam": "No Charge",
          "RoutineMammograms": "No Charge",
          "OfficeVisit": "10% after deductible",
          "SpecialistOfficeVisit": "10% after deductible",
          "MaternityCareOfficeVisits": "10% after deductible",
          "DiagnosticServicesXrayAndLabTests": "10% after deductible",
          "AdvanceRadiologyMRIsAndCTScans": "$40 copay after deductible",
          "HospitalInpatientAndOutpatientSurgery": "10% after deductible",
          "EmergencyRoom": "10% after deductible",
          "Ambulance": "10% after deductible",
          "Prescriptions": {
            "Generic": "$10 copay after deductible",
            "NameBrand": "$25 copay after deductible",
            "BrandOutsideOfFormulary": "$40 copay after deductible",
            "MailOrderPrescriptions90DaySupply": {
              "Generic": "$20 copay",
              "NameBrand": "$50 copay",
              "BrandOutsideOfFormulary": "$80 copay"
            }
          }
        }
      }
    }
    `;
  const bill_1 = `
    {
      "Carrier": "PICA",
      "Patient and Insured Information": {
        "Group Health Plan ID": "G54321",
      },
      "Patient Information": {
        "Name": "David Clair",
        "Street no": "132",
        "Birth Date": "1997-05-25",
        "Sex": "M",
        "Relationship to Insured": "Spouse",
        "City": "Kingston",
        "State": "NY",
        "Zip Code": "12401",
        "Telephone": "555-153-4361",
        "Marital Status": "Married"
      },
      "Insured Information": {
        "Insured's Name": "",
        "Date of Birth": "01-20-1994",
        "Sex": "F",
        "Employment": "YES",
        "Auto Accident": "NO",
        "Other Accident": "NO",
        "Insurance Plan Name": "PPO"
      },
      "Claim Information": {
        "Outside Lab Charges": "$0",
        "Service Dates": "05-01-2023",
        "Service provider name": "The heart centre",
        "Service provider address": "33 grand st. suite 53, kingston ",
        "Procedures, Services, or Supplies": [
          {
            "Date": "05-01-2023",
            "Service Type": "Emergency",
            "CPT/HCPCS": "99281",
            "Modifier": "25",
            "Charges": "$100",
            "Days or Units": "1 hr",
          },
          {
            "Date": "05-01-2023",
            "Service Type": "Ambulance",
            "CPT/HCPCS": "A0429",
            "Charges": "$400",
            "Days or Units": "2 km",
          },
          {
            "Date": "05-01-2023",
            "Service Type": "echocardiography",
            "CPT/HCPCS": "93306",
            "Charges": "$300",
            "Days or Units": "1",
          }
        ],
        "Federal Tax ID Number": "123123123",
        "Patient's Account No.": "1550",
        "Total Charge": "800",
        "Amount Paid": "650",
        "Balance": "150"
      }} 
    `;
  const bill_2 = `
    {
      "insurance_type": "Group health plan",
      "insured_id": "187-837-3728",
      "patient_name": "David Clair",
      "patient_birth_date": "1997-05-25",
      "patient_sex": "M",
      "insured_name": "Laura Carter",
      "patient_address": "132, My Street",
      "patient_city": "Kingston",
      "patient_state": "NY",
      "patient_zip": "12401",
      "patient_telephone": "555-153-4361",
      "patient_insured_relationship": "Spouse",
      "insured_address": "264, My Street",
      "insured_city": "Kingston",
      "insured_state": "NY",
      "insured_zip": "12401",
      "insured_telephone": "555-153-4361",
      "marriage_status": "Married",
      "employment_status": "YES",
      "insurance_plan_name": "PPO",
      "employment": "YES",
      "auto_accident": "NO",
      "other_accident": "NO",
      "insured_policy_group_feca_number": "G54321",
      "insured_dob": "1994-01-20",
      "insured_sex": "F",
      "insured_insurance_plan_name": "PPO",
      "items": [
        {
          "date_of_service_from": "05-01-2023",
          "date_of_service_to": "05-01-2023",
          "type_of_service": "Emergency",
          "procedure_service_or_supplies": "Emergency",
          "cpt_hcpcs": "93281",
          "charges": "100",
          "days_or_units": "1",
        },
        {
          "date_of_service_from": "05-01-2023",
          "date_of_service_to": "05-01-2023",
          "type_of_service": "Ambulance",
          "procedure_service_or_supplies": "Ambulance service",
          "cpt_hcpcs": "A0424",
          "charges": "400",
          "days_or_units": "1",
        },
        {
          "date_of_service_from": "05-01-2023",
          "date_of_service_to": "05-01-2023",
          "type_of_service": "Diagnostic",
          "procedure_service_or_supplies": "Echocardiography",
          "cpt_hcpcs": "93206",
          "charges": "300",
          "days_or_units": "1",
        }
      ],
      "federal_tax_id": "123123123",
      "patient_account_no": "1550",
      "accept_assignment_yes_no": "YES",
      "total_charge": "800",
      "amount_paid": "650",
      "balance_due": "150",
      "service_facility_location": "The heart centre, 33 grand st. suite 53, kingston",
    }
    `;

  const bill_3 = `
    {
      "Carrier": "PICA",
      "Patient and Insured Information": {
        "Group Health Plan ID": "G54321",
      },
      "Patient Information": {
        "Name": "David Clair",
        "Street no": "132",
        "Birth Date": "1997-05-25",
        "Sex": "M",
        "Relationship to Insured": "Spouse",
        "City": "Kingston",
        "State": "NY",
        "Zip Code": "12401",
        "Telephone": "555-153-4361",
        "Marital Status": "Married",
        "Drinking status": "often",
        "Smoking status": "sometimes"
      },
      "Insured Information": {
        "Insured's Name": "Laura Carter",
        "Date of Birth": "01-20-1994",
        "Sex": "F",
        "Employment": "YES",
        "Auto Accident": "NO",
        "Other Accident": "NO",
        "Insurance Plan Name": "PPO"
      },
      "Claim Information": {
        "Outside Lab Charges": "$0",
        "Service Dates": "05-01-2023",
        "Service provider name": "The heart centre",
        "Service provider address": "33 grand st. suite 53, kingston ",
        "Procedures, Services, or Supplies": [
          {
            "Date": "05-01-2023",
            "Service Type": "Emergency",
            "CPT/HCPCS": "99281",
            "Modifier": "25",
            "Charges": "$100",
            "Days or Units": "1",
          },
          {
            "Date": "05-01-2023",
            "Service Type": "Ambulance",
            "CPT/HCPCS": "A0429",
            "Charges": "$200",
            "Days or Units": "1",
          },
          {
            "Date": "05-01-2023",
            "Service Type": "echocardiography",
            "CPT/HCPCS": "93306",
            "Charges": "$300",
            "Days or Units": "1",
          }
        ],
        "Federal Tax ID Number": "123123123",
        "Patient's Account No.": "1550",
        "Total Charge": "600",
        "Amount Paid": "550",
        "Balance Due": "50"
      }}
    `;
  const cuff_tear = `{
      "date":"05-01-2023",
      "radiograph": {
          "patient_name": "David Clair",
          "age": 55,
          "sex": "Male",
          "date_of_mri": "2023-03-08",
          "impression": [
              "Rotator cuff tear",
              "Glenohumeral joint dislocation",
              "Acromioclavicular joint dislocation"
          ],
          "findings": [
              "There is a complete tear of the supraspinatus tendon.",
              "There is a dislocation of the glenohumeral joint.",
              "There is a dislocation of the acromioclavicular joint."
          ],
          "labels": [
              "Rotator cuff tear",
              "Glenohumeral joint dislocation",
              "Acromioclavicular joint dislocation"
          ]
      }
    }`;
  const Echocardiography = `{
      "specimenReceived": "Echocardiography of  heart (2D and Doppler)",
      "date":"05-01-2023",
      "interpretation": {
        "leftVentricle": {
          "dilation": "mild",
          "wallThickness": "normal"
        },
        "pericardialEffusion": {
          "amount": "small",
          "description": "Present"
        },
        "rightVentricle": {
          "size": "normal",
          "function": "normal"
        },
        "valvularFunction": {
          "regurgitation": "none",
          "stenosis": "none"
        },
        "aorta": {
          "size": "normal",
          "flow": "normal"
        },
        "pulmonaryArtery": {
          "size": "normal",
          "flow": "normal"
        },
        "inferiorVenaCava": {
          "dilation": "slightly",
          "flow": "normal"
        },
        "hepaticVeins": {
          "size": "normal",
          "flow": "normal"
        },
        "portalVein": {
          "size": "normal",
          "flow": "normal"
        },
        "spleen": {
          "size": "normal",
          "echogenicity": "normal"
        },
        "kidneys": {
          "size": "swollen",
          "echogenicity": "abnormal",
          "impression": "Probability of consumption of alcohol"
        },
        "gallbladder": {
          "size": "normal",
          "wallThickness": "normal",
          "stones": "none"
        },
        "pancreas": {
          "size": "normal",
          "echogenicity": "normal"
        },
        "retroperitonealLymphNodes": "not enlarged"
      },
      "diagnosis": "Mild left ventricular dilatation with pericardial effusion",
      "impression": "The findings are suggestive of a non-specific pericardial effusion"
    }`;
  const blank_bill = `{
      "insurance_type": "",
      "insured_id": "",
      "patient_name": "",
      "patient_birth_date": "",
      "patient_sex": "",
      "insured_name": "",
      "patient_address": "",
      "patient_city": "",
      "patient_state": "",
      "patient_zip": "",
      "patient_telephone": "",
      "patient_insured_relationship": "",
      "insured_address": "",
      "insured_city": "",
      "insured_state": "",
      "insured_zip": "",
      "insured_telephone": "",
      "marriage_status": "",
      "employment_status": "",
      "other_insured_name": "",
      "other_insured_policy_number": "",
      "other_insured_dob": "",
      "other_insured_sex": "",
      "employer_school_name": "",
      "insurance_plan_name": "",
      "employment": "",
      "auto_accident": "",
      "other_accident": "",
      "local_use": "",
      "insured_policy_group_feca_number": "",
      "insured_dob": "",
      "insured_sex": "",
      "insured_employer_school_name": "",
      "insured_insurance_plan_name": "",
      "health_benefit_plan": "",
      "patient_authorized_signature": "",
      "signature_date": "",
      "insured_authorized_signature": "",
      "items": [
        {
          "date_of_service_from": "",
          "date_of_service_to": "",
          "place_of_service": "",
          "type_of_service": "",
          "procedure_service_or_supplies": "",
          "cpt_hcpcs": "",
          "diagnosis_code": "",
          "charges": "",
          "days_or_units": "",
          "epsdt_family_plan": "",
          "emg": "",
          "cob": "",
          "reserved_for_local_use": ""
        },
        {
          "date_of_service_from": "",
          "date_of_service_to": "",
          "place_of_service": "",
          "type_of_service": "",
          "procedure_service_or_supplies": "",
          "cpt_hcpcs": "",
          "diagnosis_code": "",
          "charges": "",
          "days_or_units": "",
          "epsdt_family_plan": "",
          "emg": "",
          "cob": "",
          "reserved_for_local_use": ""
        }
      ],
      "federal_tax_id": "",
      "ssn_or_ein": "",
      "patient_account_no": "",
      "accept_assignment_yes_no": "",
      "total_charge": "",
      "amount_paid": "",
      "balance_due": "",
      "physician_or_supplier_signature": "",
      "signature_date": "",
      "service_facility_location": "",
      "billing_provider_pin": "",
      "billing_provider_grp": ""
    }
    `;

  const AddDenial = `You are an assistant with a goal of extracting particulat text from user message.
      - When user clicks on "Add denial reason":
      - Ask user, "Select one of the EMR bill" note: provide dropdown (With D in capital) like - Dropdown: ['Missing info EMR', 'Wrong codes EMR', 'Correct EMR']
              If user selects 'Missing info EMR' consider ${bill_1} as claim form
              If user selects 'Wrong codes EMR' consider ${bill_2} as claim form
              If user selects 'Correct EMR' consider ${bill_3} as claim form
      - Ask user, "Please provide the reason for denial provided by insurance company."
      - after user provides the reason,
        say, 'Please confirm denial reason: 
              "denialReason": {
                  "reason": "text provided by user"    
                }'
        note: do not use json ''' also provide buttons array like, (note: Buttons B should be capital) Buttons: ['Add reason', 'Cancel]
      - Ask user, "Do you need any other help?"
      `;

  const VerifyClaimContext = `You are an assistant with a goal of verifying the EMR claim form to reduce denial of claims.
        You have access to submitted claim forms, patient details, services provided by physician/hospital, patient policy plan, patient diagnosis reports and previous denial reasons.
        Here is the json of previous denial reason - ${rules} note: this json has more weightage than policy json
        Here is the json for medical plan - ${policy}
        Here is the json for patient information - ${patient_david}
        Follow these instructions:
        - Only provide denial reasons if found. DO NOT provide the JSON of selected documents.
        - Ask user, "Are you sure you want to verify claim bill for David Clair." note: use html <b> tag for name of patient-"David Clair", also provide Buttons array (With B in capital) like - Buttons: ['Yes', 'Cancel']
        - If user clicks "Yes":
          - Ask user, "Select one of the EMR bill" note: provide dropdown (With D in capital) like - Dropdown: ['Missing info EMR', 'Wrong codes EMR', 'Correct EMR']
              If user selects 'Missing info EMR' consider ${bill_1} as claim form
              If user selects 'Wrong codes EMR' consider ${bill_2} as claim form
              If user selects 'Correct EMR' consider ${bill_3} as claim form
          - Ask user, "Select one of the Diagnosis Report" note: provide dropdown (With D in capital) like - Dropdown: ['Echocardiography', 'Cuff Tear']
              If user selects 'Cuff Tear' consider ${cuff_tear} as diagnosis report
              If user selects 'Echocardiography' consider ${Echocardiography} as diagnosis report
          - Ask user, "Select one of the services document" note: provide dropdown (With D in capital) like - Dropdown: ['ER & Ambulance', 'Syringe & Room']
              If user selects 'ER & Ambulance' consider ${ER_Ambulance} as services provided report
              If user selects 'Syringe & Room' consider ${Syringe_Room} as services provided report
          - Ask to user, "Do you want to upload authourization documents?" note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Upload authorization documents', 'Cancel']
            If user says 'Upload authorization documents' then ask user to upload document like, "Choose file to upload" and store uploaded file name in ${filename1} note: also provide Buttons array(note: Buttons B should be capital) like this, Buttons: ['Cancel']
            If user says 'file_name' store filename in ${filename1} and ${selectedFile} and say "file_name successfully uploaded" and ask following 
          - If claim gets denied, say,"Claim may get denied due to the following reasons: " and display if any reasons found by comparing details in selected claim form against patient details, diagnosis report, services document, ${policy}, ${rules} and ${authFile}.
            note: give priority to denial reason over policy. use html tags like <b>, <h4> for formatting.
            say, "Here is the corrected bill json" and refer ${blank_bill} to fill the corrected values so that it won't be denied and provide in json format. 
            note: put 2 whitespace for empty feilds. Do not remove any feilds from selected claim form.
            Ask user, "Do you want to see corrected bill?" note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Show correct bill', 'Cancel']
                If user clicks 'Show correct bill', say "Here is the generated correct bill: " and show corrected bill. follow these instructions to generated correct bill:
                  consider ${blank_bill} to fill the correct values. 
                  do not change the keys in ${blank_bill} and put 2 whitespace for empty feilds. 
                  also consider common medical rates to fill "charge" feild with an estimated amount. 
                  make sure none of the reasons in ${rules} satisfy for the generated claim.
          - If the claim is not denied only return "Claim form won't be denied." 
          - Ask user, "Do you want Patient's bill" note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Show Patient Bill', 'Cancel']
          if user clicks 'Show Patient Bill'. say, "Here is the patient's bill: " and show updated patient's bill. Follow these instructions to generate patient bill:
            refer ${policy} to calculate insurance payments.
            map the charges mentioned in selected EMR/EHR bill in below json.
            patient_payments is the total amount to be paid by patient
            bill should be in the json format as:
          {
            "account_number": "",
            "amount_due": "",
            "due_date": "",
            "medications":[{
                  "date": "",
                  "code": "",
                  "description": "",
                  "charges": "",
                  "insurance_payments": "",
                  "patient_payments": "",
                  "adjustments": "",
                  "balance": ""
              }],
            "statement_date": "",
            "invoice_number": "",
            "patient_name": "",
            "current":"",
            "over_30_days":"",
            "over_60_days":"",
            "over_90_days":"",
            "over_120_days":""
          }
          - Ask user, "Do you need any other help?"
          `;

  const generateClaimContext = `
        You are an assistant with a goal of generating the EMR claim form such that it won't be denied.
        You have access to patient details, services provided by physician/hospital, patient policy plan, patient diagnosis reports and previous denial reasons.
        Here is the json for common denial reason - ${rules}
        Here is the json for medical plan - ${policy}
        Here is the json for patient information - ${patient_david}
        Follow these instructions:
        - Ask user, "Are you sure you want to generate claim bill for David Clair." note: use html <b> tag for name of patient-"David Clair", also provide Buttons array (With B in capital) like - Buttons: ['Yes', 'Cancel']
        - If user clicks "Yes":
          - Ask user, "Select one of the diagnosis report" note: provide dropdown (With D in capital) like - Dropdown: ['Cuff Tear', 'Echocardiography']
              If user selects 'Cuff Tear' consider ${cuff_tear} as diagnosis report
              If user selects 'Echocardiography' consider ${Echocardiography} as diagnosis report
          - Ask user, "Select one of the services document" note: provide dropdown (With D in capital) like - Dropdown: ['ER & Ambulance', 'Syringe & Room']
              If user selects 'ER & Ambulance' consider ${ER_Ambulance} as services provided report
              If user selects 'Syringe & Room' consider ${Syringe_Room} as services provided report
          - Check if any prior authorization documents are required for the selected diagnosis as per ${policy} 
              If any prior authorization documents are required, say to user, "Authorization documents require." ask user, "Do you want to upload authourization documents?" note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Upload authorization documents', 'Cancel']
              If user says 'Upload authorization documents' then ask user to upload document like, "Choose file to upload" and store uploaded file name in ${filename1} note: also provide Buttons array(note: Buttons B should be capital) like this, Buttons: ['Cancel']
              If user says 'file_name' store filename in ${filename1} and ${selectedFile} and say "file_name successfully uploaded"
          - say, "Here is the generated insurance bill: " and follow these instructions to generate insurance bill:
            Consider selected details to fill ${blank_bill}. 
            Do not change the keys in ${blank_bill} and put 2 whitespace for empty feilds. 
            Consider prices mentioned in selected service report and ${authFile} to fill "charge" feild in generated claim as well as patient bill json below.
            and make sure none of the reasons in ${rules} satisfy for the generated claim. 
            display generated claim form in json format also, note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Show Patient Bill', 'Cancel']
          - Ask user, "Do you want Patient's bill" note: provide Buttons array(with B in Buttons capital) like - Buttons: ['Show Patient Bill', 'Cancel']
            if user clicks 'Show Patient Bill'. say, "Here is the patient's bill: " and show updated patient's bill. Follow these instructions to generate patient bill:
              refer ${policy} to calculate insurance payments.
              map the charges mentioned in selected EMR/EHR bill in below json.
              balance is the total amount to be paid by patient
              bill should be in the json format as:
            {
              "account_number": "",
              "amount_due": "",
              "due_date": "",
              "medications":[{
                    "date": "",
                    "code": "",
                    "description": "",
                    "charges": "",
                    "insurance_payments": "",
                    "patient_payments": "",
                    "adjustments": "",
                    "balance": ""
                }],
              "statement_date": "",
              "invoice_number": "",
              "patient_name": "",
              "current":"",
              "over_30_days":"",
              "over_60_days":"",
              "over_90_days":"",
              "over_120_days":""
            }
          - Ask user, "Do you need any other help?"
          `;

  const handleDropdownChange = async (event) => {
    demo = event.target.value;
    let nContext;
     
    nContext = [...context, { role: "user", content: event.target.value }];
    
    setContext(nContext);
    const userMessage = {
      text: event.target.value,
      user: true,
    };
    let aiResponse = {
      text: "please wait...",
      user: false,
    };
    setmessagesa((prevmessagesa) => [
      ...prevmessagesa,
      userMessage,
      aiResponse,
    ]);
    // //speak({ text: aiResponse.text, voice: voices[4] });
    getCompletionFrommessagesa(nContext);
    SetDropdownNames([]);
  };
  
  const getCompletionFrommessagesa = async (ncontext) => {
    if (
      !demo.toLowerCase().includes("start new conversation") &&
      !demo.toLowerCase().includes("reset") &&
      !demo.toLowerCase().includes("exit chat")
    ) {
      // questionCount();
    }
    // if (count < limit) {
      try {
        const body = {
          ncontext: ncontext,
          user_id: loggedInUserId,
        };
        let res = await axios.post(`${OPENAI_API}get_ai_res`, body);
        let assres = res.data.assres;
        let answer = res.data.assres;
        let pdfData;
        let reportres;
        setAnswer(answer);

        if (assres !== null) {
          if (assres.includes("checkbox")) {
            checkboxtable = assres.split("Buttons:")[0];
          }

          if (assres.includes("ask your questions")) {
            console.log("user question", response, demo);
          }
          if (
            demo === "Yes, claim" ||
            demo === "Upload authorization documents"
          ) {
            SetShowFileUpload(true);
          }
          if (assres.includes("successfully uploaded")) {
            let a_url = await upload_authorization_file();
            let blob_url = a_url.split("?")[0];
            console.log("file url: ", blob_url);
            demo = `<p><a href = "${blob_url}" target = "_blank">authorization document</a></p>`;
            let summary = await report("summarize the document", blob_url);
            console.log("file data: ", summary);
            setAuthFile(summary);
          }
          if (demo === "Cuff Tear") {
            demo = `<span><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/cuff_tear.pdf" target="_blank">Cuff Tear</a></span>`;
          }
          if (demo === "Echocardiography") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/echocardiography.pdf" target = "_blank">Echocardiography</a></p>`;
          }
          if (demo === "ER & Ambulance") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/ER_ambulance_services.pdf" target = "_blank">ER & Ambulance</a></p>`;
          }
          if (demo === "Syringe & Room") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/Syringe_Room.pdf" target = "_blank">Syringe & Room</a></p>`;
          }
          if (demo === "Missing info EMR") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/BILL 22.pdf" target = "_blank">Missing info EMR</a></p>`;
          }
          if (demo === "Wrong codes EMR") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/BILL 11.pdf" target = "_blank">Wrong codes EMR</a></p>`;
          }
          if (demo === "Correct EMR") {
            demo = `<p><a href = "https://blobtimesheet.blob.core.windows.net/insurancedocs/bill_new.pdf" target = "_blank">Correct EMR</a></p>`;
          }
          if (demo.includes("Continue")) {
            SetShowFileUpload(false);
            // setSelectedFile(null);
          }
          if (demo === "Continue upload" || demo.includes("file_name")) {
            SetShowFileUpload(false);
            // await handleUploadVideoAPI(10);
          }
          if (
            demo.includes("Process Claim") ||
            demo.includes("services_name")
          ) {
            SetShowFileUpload(false);
            reportres = await handleReportSelectAPI();
            // setSelectedFile(null);
          }
          if (assres.toLowerCase().includes("revenue code")) {
            console.log("asses res for Show bill", assres);
            let pdfres = assres;
            const body = {
              payload: pdfres,
            };
            pdfData = await axios.post(
              `${OPENAI_API}generate_insurance_claim_pdf`,
              body
            );

            console.log("resdata...", pdfData.data.pdf_url);
            let nContext = [
              ...context,
              {
                role: "system",
                content: `Here is your pdf link ${pdfData.data.pdf_url}`,
              },
            ];
            setContext(nContext);
          }
          let doc;
          if (assres.includes("denialReason")) {
            await extractdenialjson(assres);
            console.log("denial_reasons", res);
          }
          if (assres.includes("Here is the corrected")) {
            let new_pdf_url = await extractbill(assres);
            console.log("new_pdf_url", new_pdf_url);
            assres = new_pdf_url;
          }
          if (assres.includes("Here is the generated")) {
            let new_pdf_url = await extractbill(assres);
            let new_bill_url = await get_bill_url();
            let url = `<p><a href = "${new_bill_url.data.pdf_url}" target = "_blank">Generated Bill</a></p>`;
            let answer =
              "Here is the link for the generated bill: \n" +
              url +
              "\n Buttons: ['Show Patient Bill', 'Cancel']";
            assres = answer;
          }
          if (assres.includes("Here is the patient's")) {
            let new_pdf_url = await extractbill(assres);
            console.log("new_pdf_url", new_pdf_url);
            let new_bill_url = await get_bill_patient();
            let url = `<p><a href = "${new_bill_url.data.pdf_url}" target = "_blank">Patient Bill</a></p>`;
            let answer =
              "Here is the link for patient's bill: \n" +
              url +
              "Do you need any other help?";
            assres = answer;
          }
          if (demo === "Cancel") {
            SetShowFileUpload(false);
          }
          if (assres.toLowerCase().includes("dropdown:")) {
            let dropdownopt = extractDropdownopt(assres);
            console.log("get completion dropdown: ", dropdownopt);
            SetDropdownNames(dropdownopt);
          }
          if (assres.includes("Do you need any other help?")) {
            setIsButtonDisabled((prevState) => !prevState);
            // setIsButtonDisabled(false)
            specialistName = "";
            uploadVideoFileUrl = "";
            SetPdfUrl([]);
            setClickedButton("");
            setmessagesa([]);
            SetbuttonNames([]);
            SetDropdownNames([]);
            SetShowFileUpload(false);
            setThreadButtonClicked(false);
            setContext(initialContext);
            setIsGeneralSearch(false);
            Setisexpbutton(false);
            SetisOtherQue(false);
            setSelectedFile(null);
            file = "";
          }
          SettextBeforeButtons(assres.split("Buttons:")[0]);
          let textBeforeBut = "";
          if (assres.toLowerCase().includes("dropdown:")) {
            textBeforeBut = assres.toLowerCase().split("dropdown:")[0];
          } else if (assres.includes("userDoc-data")) {
            textBeforeBut = assres.split('"userDoc-data":')[0];
          } else if (assres.includes("Buttons:")) {
            textBeforeBut = assres.split("Buttons:")[0];
          } else {
            textBeforeBut = assres;
          }
          let userMessage;
          let newContext;
          if (assres.toLowerCase().includes("revenue code")) {
            userMessage = { text: response, user: true };
            newContext = [
              ...ncontext,
              { role: "assistant", content: assres },
              {
                role: "system",
                content: `Here is your pdf link ${pdfData.data.pdf_url}`,
              },
            ];
          } else if (response !== "") {
            userMessage = { text: response, user: true };
            newContext = [...ncontext, { role: "assistant", content: assres }];
          } else if (demo.includes("services_name")) {
            userMessage = { text: demo, user: true };
            newContext = [
              ...ncontext,
              { role: "assistant", content: assres },
              {
                role: "system",
                content:
                  "Services provided by physician and their units as follows: \n" +
                  reportres,
              },
            ];
          } else if (demo === "Yes" || assres.includes("withphi-data")) {
            console.log("doc called");
            userMessage = { text: demo, user: true };
            newContext = [
              ...ncontext,
              { role: "assistant", content: assres },
              {
                role: "system",
                content: `patient documents are: ${JSON.stringify(doc)}`,
              },
            ];
          } else {
            userMessage = { text: demo, user: true };
            newContext = [...ncontext, { role: "assistant", content: assres }];
          }
          let aiResponse = { text: textBeforeBut, user: false };
          if (demo.includes("New") || demo.includes("Exit")) {
            setmessagesa([userMessage, aiResponse]);
            // //speak({ text: aiResponse.text, voice: voices[4] });
          } else {
            setmessagesa([...messagesa, userMessage, aiResponse]);
            // //speak({ text: aiResponse.text, voice: voices[4] });
          }
          if (assres.includes("Button")) {
            var buttonN = extractButtonNames(assres);
            SetbuttonNames(buttonN);
          }
          setContext(newContext);
          setResponse("");
          if (!threadApiCalled) {
            const obj = { question: demo, email: loggedInUserEmail };
            const add_thread = await axios.post(`${ACS_API}send_thread`, obj);
            // const add_thread = await axios.post(`http://127.0.0.1:5000/send_thread`, obj);
            thread_id = add_thread.data.new_row.Id;
            setThreadApiCalled(true);
            const response = await axios.get(
              `${ACS_API}get_all_threads/${loggedInUserEmail}`
            );
            // const response = await axios.get(`http://127.0.0.1:5000/get_all_threads/${loggedInUserEmail}`);
            categorizeThreads(response.data);
          }
          if (!(demo === "Start New Conversation")) {
            send_msg_func(demo, textBeforeBut, thread_id);
          }
        }
      } catch (error) {
        console.error("Error fetching AI response", error);
      }
    // } else {
    //   let userMessage = { text: "", user: true };
    //   let aiResponse = {
    //     text: "You have reached your daily question limit",
    //     user: false,
    //   };
    //   setmessagesa([userMessage, aiResponse]);
    //   // //speak({ text: aiResponse.text, voice: voices[4] });
    // }
  };

  useEffect(() => {
    if (messagesa.length > 0 && lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messagesa]);

  const handleFileSelect = (event) => {
    file = event.target.files && event.target.files[0];
    console.log("file in file select", file);
    if (file) {
      fileNames = file.name;
      setFilename1(fileNames);
      if (demo === "Yes upload video") {
        demo = `file_name ${fileNames}`;
      } else if (demo === "Yes, claim") {
        demo = `services_name ${fileNames}`;
      } else if (demo === "Upload authorization documents") {
        demo = `authorization document: ${fileNames}`;
      }
      let nContext = [
        ...context,
        { role: "system", content: `You have selected file name ${fileNames}` },
        { role: "user", content: demo },
      ];
      setContext(nContext);
      setSelectedFile(file);
      const userMessage = { text: demo, user: true };
      let aiResponse = { text: "Please wait...", user: false };
      setmessagesa((prevmessagesa) => [
        ...prevmessagesa,
        userMessage,
        aiResponse,
      ]);
      SetShowFileUpload(false);
      SetbuttonNames([]);
      if (filename1 === undefined || filename1 === null) {
        setFilename1(fileName);
        setSelectedFile1(file);
      } else if (filename2 === undefined || filename2 === null) {
        setFilename2(file.name);
        setSelectedFile2(file);
      } else if (filename3 === undefined || filename3 === null) {
        setFilename3(file.name);
        setSelectedFile3(file);
      }
      getCompletionFrommessagesa(nContext);
    }
  };

  const ClaimPdf = async () => {};

  const handleSendMessage = async () => {
    if (response.trim() !== "") {
      // setIsMicrophoneOn(false);
      let prompt = response;
      demo = response;
      setResponse("");
      if (!isotherQue && !isvideoQue) {
        SetbuttonNames([]);
      }
      SetDropdownNames([]);
      let nContext = [];
      if (
        prompt.toLowerCase().includes("top 5 documents") ||
        prompt.toLowerCase().includes("see my documents") ||
        prompt.toLowerCase().includes("documents")
      ) {
        SetbuttonNames([
          "Compare",
          "Summarize",
          "Anatomical Abnormalities",
          "Other Question",
          "Reset",
        ]);
        let aiResponse = { text: html_table, user: false };
        let userMessage = { text: demo, user: true };
        setmessagesa([...messagesa, userMessage, aiResponse]);
      } else if (
        prompt.toLowerCase().includes("exit chat") ||
        prompt.toLowerCase().includes("thanks")
      ) {
        nContext = [
          { role: "system", content: newChat },
          { role: "user", content: "New Chat" },
        ];
        Setisfaqbutton(false);
        SetDropdownNames([]);
        setClickedButton("");
        setIsGeneralSearch(false);
        Setisexpbutton(false);
      }  
      else {
        nContext = [...context, { role: "user", content: prompt }];
      }

      if (
        !prompt.toLowerCase().includes("top 5 documents") &&
        !prompt.toLowerCase().includes("see my documents") &&
        !prompt.toLowerCase().includes("my documents")
      ) {
        setContext(nContext);
        const userMessage = { text: prompt, user: true };
        let aiResponse = { text: "Please wait...", user: false };
        setmessagesa((prevmessagesa) => [
          ...prevmessagesa,
          userMessage,
          aiResponse,
        ]);
        //speak({ text: aiResponse.text, voice: voices[4] });
        if (
          isGeneralSearch &&
          !prompt.includes("Hi") &&
          !prompt.includes("exit chat") &&
          prompt.includes("?")
        ) {
          SetbuttonNames([]);
          console.log("in general sql search api called");
        } else if (!prompt.includes("thanks")) {
          try {
            const body = {
              question: response,
              loggedInUserRoleId: loggedInUserRoleId,
            };
          } catch (err) {
            console.error("Error:", err);
          }
        } else if (isotherQue && !prompt.includes("thanks")) {
          // const r1 = await report(prompt, pdfUrl);
          let r1;
          if (pdfUrl.length > 0) {
            r1 = await report(prompt, pdfUrl);
          }
          if (imageUrl.length > 0) {
            r1 = await report(prompt, imageUrl);
          }
          aiResponse = { text: r1, user: false };
          let userMessage = { text: prompt, user: true };
          setmessagesa([...messagesa, userMessage, aiResponse]);
          //speak({ text: aiResponse.text,voice: voices[4] });
          send_msg_func(demo, r1, thread_id);
          // questionCount();
        } else if (isvideoQue && !prompt.includes("thanks")) {
          let r1;
          if (videoUrl.length !== 0) {
            r1 = await report(prompt, videoUrl);
          } 
          aiResponse = { text: r1, user: false };
          let userMessage = { text: prompt, user: true };
          setmessagesa([...messagesa, userMessage, aiResponse]);
          //speak({ text: aiResponse.text,voice: voices[4] });
          send_msg_func(demo, r1, thread_id);
          // questionCount();
        } else {
          try {
            getCompletionFrommessagesa(nContext); // Wait for completion
          } catch (error) {
            console.error("Error sending message", error);
          }
        }
      }
    }
  };

  function handleExitChat(event) {
    // event.preventDefault();
    if (!isButtonDisabled) {
      SweetAlertHelper.showConfirm(
        "Would you like to exit from the current chat context and initiate a new conversation?",
        () => {
          setIsButtonDisabled((prevState) => !prevState);
          specialistName = "";
          uploadVideoFileUrl = "";
          SetPdfUrl([]);
          setClickedButton("");
          setmessagesa([]);
          SetbuttonNames([]);
          SetDropdownNames([]);
          setThreadButtonClicked(false);
          setIsGeneralSearch(false);
          Setisfaqbutton(false);
          Setisexpbutton(false);
          SetShowFileUpload(false);
          SetisOtherQue(false);
          SetisVideoQue(false);
          setSelectedFile(null);
          demo = "Start New Conversation";
          let nContext = [
            { role: "system", content: newChat },
            { role: "user", content: "New Chat" },
          ];
          // setContext(nContext);
          setContext(initialContext);
          setThreadApiCalled(false);
          // Create messages for user action and AI response
          const userMessage = {
            text: "Start New Conversation",
            user: true,
          };
          let aiResponse = {
            text: "please wait...",
            user: false,
          };
          setmessagesa([userMessage, aiResponse]);
          //speak({ text: aiResponse.text, voice: voices[4] });
          getCompletionFrommessagesa(nContext); // Reset clicked button state
        }
      );
    }
  }

  useEffect(() => {}, [setClickedButton]);

  async function handleStaticButton(buttonName) {
    setActiveClicked(true);
    setClickedButton(buttonName);
    setIsButtonDisabled(false);
    let nContext;
    demo = buttonName; 

    if (buttonName.toLowerCase() === "insurance claim") {
      nContext = [
        { role: "system", content: generateClaimContext },
        { role: "user", content: "Insurance Claim" },
      ];
      Setisexpbutton(true);
      Setisfaqbutton(false);
    } else if (buttonName.toLowerCase() === "verify insurance claim") {
      nContext = [
        { role: "system", content: VerifyClaimContext },
        // { role: "system", content: insuranceClaimJsonContext },
        { role: "user", content: "verify insurance claim" },
      ];
      Setisexpbutton(true);
      Setisfaqbutton(false);
    } else if (buttonName.toLowerCase() === "add denial reason") {
      nContext = [
        { role: "system", content: AddDenial },
        // { role: "system", content: insuranceClaimJsonContext },
        { role: "user", content: "add denial reason" },
      ];
      Setisexpbutton(true);
      Setisfaqbutton(false);
    }

    setContext(nContext);
    const userMessage = {
      text: buttonName,
      user: true,
    };
    let aiResponse = {
      text: "please wait...",
      user: false,
    };
    setmessagesa([...messagesa, userMessage, aiResponse]);
    //speak({ text: aiResponse.text, voice: voices[4] });
    getCompletionFrommessagesa(nContext);
    SetbuttonNames([]);
  }

  useEffect(() => {
    // Scroll to the bottom when the component is initially rendered
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  }, []);

  useEffect(() => {
    // Scroll to the last message when messages change
    if (messagesa.length > 0 && lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messagesa]);

  return (
    <div>
      {isLoading && (
        <div className="page-loader">
          <img src="../../assets/images/ajax-loader.gif" alt="loader" />
        </div>
      )}
      <div className="chat-container" ref={chatContainerRef}>
        <div
          className="nav-bar"
          style={{
            display: isSidebarOpen ? "block" : "none",
            alignItems: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            {/* <h5 style={{ marginLeft: "11px" }}>
              {" "}
              <strong style={{ color: "blcak" }}>Chat History</strong>{" "}
            </h5> */}
            {/* <img src={sstlogo} alt="SSTLogo" style={{ width: "80px" }} /> */}
            <img
              src={sstlogo}
              alt="SSTLogo"
              className="spaced-img"
              style={{ width: "80px", height: "50px", margin: "0 20px" }}
              // style={{ width: "80px" }}
            />
          </div>

          <button
            // className="exist-button-history"
            className={`exist-button ${
              isButtonDisabled ? "disabled-class" : "enabled-class"
            }`}
            // className="send-button"
            onClick={handleExitChat}
            // disabled={count >= limit && isButtonDisabled}
            disabled={isButtonDisabled}
            style={{
              width: "296px",
              padding: "7px",
              margin: "5px",
              background: "rgb(10, 49, 97)",
              border: "1px solid white",
              color: "white",
            }}
            title="Start new conversation"
          >
            <b>Start new Conversation</b>
          </button>

          <ul className="parent-nav-list">
            {todayThread.length > 0 && (
              <li>
                <strong style={{ color: "white" }}>Today</strong>
                {todayThread.map((thread, index) => (
                  <ul className="nav-list" key={index}>
                    <button
                      className={`thread_btn ${
                        activeThread === index ? "active-button" : ""
                      }`}
                      onClick={() => loadThread(thread, index)}
                    >
                      {hasMessages(thread.name) && (
                        <FontAwesomeIcon
                          icon={faMessage}
                          className="message-icon"
                        />
                      )}

                      {thread.name}
                    </button>
                  </ul>
                ))}
              </li>
            )}
            {last7DaysThreads.length > 0 && (
              <li>
                <strong style={{ color: "white" }}>Last 7 Days</strong>
                {last7DaysThreads.map((thread, index) => (
                  <ul className="nav-list" key={index}>
                    <button
                      className="thread_btn"
                      onClick={() => loadThread(thread, index)}
                    >
                      {hasMessages(thread.name) && (
                        <FontAwesomeIcon
                          icon={faMessage}
                          className="message-icon"
                        />
                      )}
                      {thread.name}
                    </button>
                  </ul>
                ))}
              </li>
            )}
            {olderThread.length > 0 && (
              <li>
                <strong style={{ color: "white" }}>Older Chats</strong>
                {olderThread.map((thread, index) => (
                  <ul className="nav-list" key={index}>
                    <button
                      className="thread_btn"
                      onClick={() => loadThread(thread, index)}
                    >
                      {hasMessages(thread.name) && (
                        <FontAwesomeIcon
                          icon={faMessage}
                          className="message-icon"
                        />
                      )}
                      {thread.name}
                    </button>
                  </ul>
                ))}
              </li>
            )}
          </ul>
        </div>
        <div className="chat-col lg-10">
          {/* <div className="count-container bold-text">
            {count} of {limit}
          </div> */}
          <div className="bold-text" style={{ alignSelf: "flex-end" }}>
            <p>
              <a
                href="https://blobtimesheet.blob.core.windows.net/insurancedocs/medical_plans_complete.pdf"
                target="_blank"
              >
                Policy plans
              </a>
              &nbsp;&nbsp;&nbsp;{" "}
              <a
                href="https://blobtimesheet.blob.core.windows.net/insurancedocs/Denialrules.txt"
                target="_blank"
              >
                Denial rules
              </a>
              &nbsp;&nbsp;&nbsp;{" "}
              <a
                href="https://blobtimesheet.blob.core.windows.net/insurancedocs/Patient_Information_David.pdf"
                target="_blank"
              >
                Patient information
              </a>
            </p>
          </div>
          {/* {count >= limit && (
            <div className="count-container bold-text" style={{ color: "red" }}>
              You have reached your daily question limit
            </div>
          )} */}

          <div className="message-container">
            {messagesa.map((message, index) => (
              <div
                key={index}
                style={{
                  alignSelf: message.user ? "flex-end" : "flex-start",
                  backgroundColor: message.user ? "#e1ffc7" : "#f0f0f0",
                  borderRadius: "10px",
                  padding: "8px 12px",
                  marginBottom: "5px",
                  maxWidth: "80%",
                }}
              >
                {message.user ? (
                  <div dangerouslySetInnerHTML={{ __html: message.text }} />
                ) : (
                  <>
                    {typeof message.text === "object" ? (
                      JSON.stringify(message.text)
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClipboard}
                            onClick={() =>
                              handleCopyToClipboard(message.text, index)
                            }
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            color={copiedIndex === index ? "green" : "#1c84c6"}
                            title={
                              copiedIndex === index ? "Copied!" : "Copy Text"
                            }
                          />
                          <FontAwesomeIcon
                            icon={
                              speaking && !isSpeechPaused ? faPause : faVolumeUp
                            }
                            onClick={handleVolumeIconClick(message.text)}
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "#1c84c6",
                            }}
                            title={
                              speaking && !isSpeechPaused ? "Pause" : "Listen"
                            }
                          />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FontAwesomeIcon icon={faRobot} /> &nbsp;
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            {message.text.includes("<table") ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: message.text,
                                }}
                              />
                            ) : (
                              message.text.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  <div
                                    dangerouslySetInnerHTML={{ __html: line }}
                                  />
                                </React.Fragment>
                              ))
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            ))}
            {dropdownNames.length > 0 && (
              <div>
                <select onChange={handleDropdownChange}>
                  <option value="">Select an option</option>
                  {dropdownNames.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {showFileUpload && (
              <div>
                <input type="file" onChange={handleFileSelect} />
                {selectedFile && <p>Selected File: {selectedFile.name}</p>}
              </div>
            )}
            {(textBeforeButtons !== "" || html_table !== "") && (
              <div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {buttonNames.map((buttonName, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <button
                        className="send-button"
                        key={index}
                        onClick={async () => {
                          demo = buttonName;
                          // setResponse(buttonName);
                          let nContext;
                          if (buttonName.includes("New")) {
                            nContext = [
                              { role: "system", content: newChat },
                              { role: "user", content: buttonName },
                            ];
                          } else if (buttonName.includes("Compare")) {
                            setIsLoading(true);
                            let aiResponse = {
                              text: "Please wait, I am processing reports...",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text,voice: voices[4] });
                            let r1;
                            if (pdfUrl.length === 2) {
                              r1 = await report("Compare the reports", pdfUrl);
                            } else {
                              r1 =
                                "Please select two pdf reports to compare. \n";
                            }
                            if (imageUrl.length > 0) {
                              // r1 = await report("For the the given image if it is MRI/CT scan or  X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points", imageUrl);
                              r1 =
                                "Please select two pdf reports to compare, I am unable to compare images. \n";
                            }
                            if (videoUrl.length > 0) {
                              // r1 = await report("For the the given image if it is MRI/CT scan or  X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points", imageUrl);
                              r1 =
                                "Please select two pdf reports to compare, I am unable to compare videos. \n";
                            }
                            // const r1 = await report("Compare the reports", pdfUrl);
                            let aire =
                              r1 +
                              "\n\nIf you have any question on this report please enter the question or else click on Reset button to choose other reports.";
                            aiResponse = {
                              text: aire,
                              user: false,
                            };
                            userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text ,voice: voices[4]});
                            // SetPdfUrl([])
                            setIsLoading(false);
                            SetisOtherQue(true);
                            SetisVideoQue(false);
                            send_msg_func(demo, aire, thread_id);
                            // questionCount();
                          }  else if (buttonName.includes("Ask Question")) {
                            let aiResponse = {
                              text: "Please type your Question in the box below",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text, voice: voices[4] });
                            SetisVideoQue(true);
                            SetisOtherQue(false);
                            // questionCount();
                          } else if (buttonName.includes("Summarize")) {
                            setIsLoading(true);
                            let aiResponse = {
                              text: "Please wait, I am processing reports...",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text, voice: voices[4] });
                            let r1;
                            if (pdfUrl.length > 0) {
                              if (pdfUrl.length !== 1) {
                                r1 =
                                  "Please select only one document to summarize!";
                              } else {
                                r1 = await report(
                                  "Summarize the report",
                                  pdfUrl
                                );
                                SetisOtherQue(true);
                              }
                            }
                            if (imageUrl.length > 0) {
                              if (imageUrl.length !== 1) {
                                r1 =
                                  "Please select only one document to summarize!";
                              } else {
                                r1 = await report(
                                  "For the the given image if it is MRI/CT scan or  X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points",
                                  imageUrl
                                );
                                SetisOtherQue(true);
                              }
                            }
                            if (videoUrl.length > 0) {
                              console.log("video url selected ");
                              r1 = await report(
                                "if it is MRI/CT scan or X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points",
                                videoUrl
                              );
                              console.log("r1 of video", r1);
                              SetisVideoQue(true);
                            }
                            let aire =
                              r1 +
                              "\n \nIf you have any question on this report please enter the question or else click on Reset button to choose other reports.";
                            aiResponse = { text: aire, user: false };
                            userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            setIsLoading(false);
                            //speak({ text: aiResponse.text,voice: voices[4] });
                            // SetPdfUrl([])

                            send_msg_func(demo, aire, thread_id);
                            // questionCount();
                          }  else if (buttonName.includes("Other Question")) {
                            let aiResponse = {
                              text: "Please type your Other Question in the box below",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text, voice: voices[4] });
                            SetisOtherQue(true);
                            SetisVideoQue(false);
                            // questionCount();
                          } else if (buttonName.includes("Reset")) {
                            let aiResponse = {
                              text: checkboxtable,
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            //speak({ text: aiResponse.text, voice: voices[4] });
                            send_msg_func(demo, checkboxtable, thread_id);
                            SetPdfUrl([]);
                            SetImageUrl([]);
                            setVideoUrl([]);
                          }  else if (buttonName === "Show correct bill") {
                            setIsLoading(true);
                            let aiResponse = {
                              text: "Please wait, I am generating correct bill...",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            SetbuttonNames([]);
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            let new_bill_url = await get_bill_url();
                            console.log("new_bill_url", new_bill_url.data);
                            let url = `<p><a href = "${new_bill_url.data.pdf_url}" target = "_blank">Correct Bill</a></p>`;
                            let answer =
                              "Here is the link for correct bill: \n" + url;
                            aiResponse = {
                              text: answer,
                              user: false,
                            };
                            userMessage = { text: demo, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            setIsLoading(false);
                            send_msg_func(demo, answer, thread_id);
                            // questionCount();
                          } else if (buttonName === "Add reason") {
                            let aiResponse = {
                              text: "Please wait... ",
                              user: false,
                            };
                            let userMessage = { text: buttonName, user: true };
                            SetbuttonNames([]);
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            let updated_url = await get_rules_url();
                            let updated_rules = `<p><a href = "${updated_url}" target = "_blank">Denial Rules</a></p>`;
                            let answer =
                              "Reason added successfully. Here is the link for rule book: \n" +
                              updated_rules +
                              "\nDo you need any other help?";
                            aiResponse = {
                              text: answer,
                              user: false,
                            };
                            userMessage = { text: demo, user: true };
                            setmessagesa([
                              ...messagesa,
                              userMessage,
                              aiResponse,
                            ]);
                            setIsLoading(false);
                            send_msg_func(demo, answer, thread_id);
                            // questionCount();
                            setIsButtonDisabled((prevState) => !prevState);
                            setClickedButton("");
                            SetShowFileUpload(false);
                            setThreadButtonClicked(false);
                            setContext(initialContext);
                          } else {
                            nContext = [
                              ...context,
                              { role: "user", content: buttonName },
                            ];
                          }
                          if (
                            buttonName !== "Compare" &&
                            buttonName !== "Summarize" &&
                            buttonName !== "Other Question" &&
                            buttonName !== "Reset" &&
                            buttonName !== "Detailed Summary" &&
                            buttonName !== "Anatomical Abnormalities" &&
                            buttonName !== "Show Summary" &&
                            buttonName !== "Ask Question" &&
                            buttonName !== "Show correct bill" &&
                            buttonName !== "Add reason" &&
                            buttonName !== "Show Prescription"
                          ) {
                            setContext(nContext);
                            const userMessage = {
                              text: buttonName,
                              user: true,
                            };
                            let aiResponse = {
                              text: "please wait...",
                              user: false,
                            };
                            if (buttonName.includes("New")) {
                              setmessagesa([userMessage, aiResponse]);
                              //speak({ text: aiResponse.text,voice: voices[4] });
                            } else {
                              setmessagesa([
                                ...messagesa,
                                userMessage,
                                aiResponse,
                              ]);
                              //speak({ text: aiResponse.text, voice: voices[4] });
                            }
                            getCompletionFrommessagesa(nContext);
                            SetbuttonNames([]);
                          }
                        }}
                      >
                        {buttonName}
                        {/* {buttonName === "Stop Dictation" && isRecording && ` (Time Left: ${formatTimeLeft()})`} */}
                      </button>
                      {buttonName === "Stop Dictation" && isRecording && (
                        <span className="digital-clock">
                          {" "}
                          {`Time Elapsed: ${formatTimeLeft()}`}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div ref={lastMessageRef}></div>
            <button
              onClick={toggleSidebar}
              className="toggle-button"
              title={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
            >
              <FontAwesomeIcon
                className="icon"
                icon={isSidebarOpen ? faChevronLeft : faChevronRight}
              />
            </button>
          </div>
          <div
            className="buttoArray"
            style={{ display: `${threadButtonClicked ? "none" : ""}`,
                      alignItems: "center",
                      flexWrap: 'wrap',
                      gap: "5px" }}
          >
          {
            (
              <>
                <button
                  className={`send-button ${
                    activeclicked && clickedButton === "verify insurance claim"
                      ? "green-class"
                      : ""
                  }`}
                  onClick={() => handleStaticButton("verify insurance claim")}
                  title="verify insurance claim"
                  disabled={
                    // count >= limit ||
                    (clickedButton !== "" &&
                      clickedButton !== "verify insurance claim") ||
                    (activeclicked &&
                      clickedButton === "verify insurance claim")
                  }
                >
                  Verify Insurance Claim
                </button>
                <button
                  className={`send-button ${
                    activeclicked && clickedButton === "insurance claim"
                      ? "green-class"
                      : ""
                  }`}
                  onClick={() => handleStaticButton("insurance claim")}
                  disabled={
                    // count >= limit ||
                    (clickedButton !== "" &&
                      clickedButton !== "insurance claim") ||
                    (activeclicked && clickedButton === "insurance claim")
                  }
                  title="Insurance Claim"
                >
                  Insurance Claim Generated by AI
                </button>
                <button
                  className={`send-button ${
                    activeclicked && clickedButton === "add denial reason"
                      ? "green-class"
                      : ""
                  }`}
                  onClick={() => handleStaticButton("add denial reason")}
                  title="add denial reason"
                  disabled={
                    // count >= limit ||
                    (clickedButton !== "" &&
                      clickedButton !== "add denial reason") ||
                    (activeclicked && clickedButton === "add denial reason")
                  }
                >
                  Add denial reason
                </button>
              </>
            )}
            <button
              className={`exist-button ${
                isButtonDisabled ? "disabled-class" : "enabled-class"
              }`}
              // className="send-button"
              onClick={handleExitChat}
              // disabled={count >= limit && isButtonDisabled}
              disabled={isButtonDisabled}
              title="Start new Conversation"
            >
              Start new Conversation
            </button>
            <span style={{ marginLeft: "auto" }}>
            <button
              className={`send-button`}
              style={{alignSelf: "end", marginRight: "120px"}}
              onClick={() => {
                navigate("/healthcareAI");
              }}
              title="Healthcare Home"
            >
              Back
            </button>
            </span>
          </div>
          <div className="chat-input-container">
            <div className="input-with-mic">
              <input
                type="text"
                placeholder="Type your message..."
                value={response}
                onChange={(e) => setResponse(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSendMessage();
                  }
                }}
                className="chat-input"
                // disabled={count >= limit || threadButtonClicked}
                disabled={threadButtonClicked}
              />
            </div>
            <button
              onClick={handleSendMessage}
              className="send-button"
              // disabled={count >= limit || threadButtonClicked}
              disabled={threadButtonClicked}
              title="Send"
            >
              Send
            </button>
            <button
              type="submit"
              onClick={resetAllData}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "blue",
                display: "flex",
                alignItems: "center",
              }}
              // disabled={count >= limit}
              title="Reset"
            >
              <FiRefreshCw
                size={20}
                style={{ marginRight: "5px", color: "#1c84c6" }}
              />
            </button>
          </div>

          <div className="ssttag">
            <img src={sstlogo} alt="SSTAI logo" className="logo" />
            <span style={{ opacity: 1 }}>SSTAI IP</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SSTAI;
